{
  "title": "Geplante Berichte",
  "subtitle": "Automatische E-Mail-Berichte für dein FBO konfigurieren",
  "status": {
    "notConfigured": "Nicht konfiguriert",
    "disabled": "Deaktiviert",
    "enabled": "Aktiviert"
  },
  "lastRun": {
    "never": "Nie",
    "justNow": "Gerade eben",
    "minutesAgo": "vor {{count}} Min.",
    "hoursAgo": "vor {{count}} Std."
  },
  "occupancy": {
    "title": "Nächtlicher Belegungsbericht",
    "subtitle": "Tägliche Flugzeugübersicht",
    "description": "Sendet automatisch jede Nacht zu einer festgelegten Zeit eine Übersicht aller Flugzeuge in Hangars und auf Abstellflächen per E-Mail."
  },
  "labels": {
    "locations": "Standorte",
    "hangars": "Hangars",
    "ramps": "Vorfelder",
    "selected": "ausgewählt",
    "snapshotTime": "Meldezeit",
    "recipients": "Empfänger",
    "emailsConfigured": "E-Mail(s) konfiguriert",
    "lastRun": "Letzter Lauf",
    "nextRun": "Nächster Lauf",
    "error": "Fehler:"
  },
  "buttons": {
    "configure": "Konfigurieren",
    "setUp": "Bericht einrichten",
    "disable": "Deaktiv."
  },
  "disableDialog": {
    "title": "Bericht deaktivieren",
    "message": "Möchtest du diesen geplanten Bericht wirklich deaktivieren? Du kannst ihn später wieder aktivieren.",
    "confirm": "Bericht deaktivieren"
  },
  "configDialog": {
    "titleNew": "Auslastungsbericht einrichten",
    "titleEdit": "Auslastungsbericht konfigurieren",
    "testEmailSent": "Test-E-Mail gesendet! Überprüfe deinen Posteingang.",
    "fields": {
      "enableReport": "Geplanten Bericht aktivieren",
      "hangars": "Hangars",
      "selectHangars": "Hangars auswählen...",
      "hangarsHelp": "Hangars für den Bericht auswählen",
      "ramps": "Vorfeld",
      "selectRamps": "Vorfelder auswählen...",
      "rampsHelp": "Wähle Vorfelder für den Bericht aus",
      "noRampsAvailable": "Keine Vorfelder verfügbar",
      "snapshotTime": "Meldezeit",
      "snapshotTimeHelp": "Wann der Bericht erfasst und gesendet werden soll",
      "recipients": "E-Mail-Empfänger",
      "recipientsHelp": "Kommagetrennte Liste von E-Mail-Adressen für den Berichtsempfang",
      "fileFormat": "Anhangsformat",
      "fileFormatHelp": "CSV öffnet sich direkt in Excel. TSV verwendet tabulatorgetrennte Werte.",
      "timezone": "Zeitzone"
    },
    "buttons": {
      "sendTest": "Test-E-Mail senden"
    },
    "errors": {
      "noLocationsSelected": "Bitte wähle mindestens einen Hangar oder ein Vorfeld aus",
      "noRecipients": "Bitte gib mindestens eine E-Mail-Adresse ein",
      "invalidEmails": "Ungültige E-Mail-Adresse(n): {{emails}}",
      "noSnapshotTime": "Bitte lege eine Meldezeit fest",
      "saveFailed": "Speichern der Berichtskonfiguration fehlgeschlagen. Bitte versuche es erneut.",
      "testFailed": "Testmail konnte nicht gesendet werden. Bitte versuche es erneut."
    }
  }
}
